var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"saas-listing-page__sidebar-small-title"},[_vm._v("Topics")]),_vm._v(" "),_c('ul',{staticClass:"saas-listing-page__categories"},_vm._l((_vm.categories),function(category){return _c('li',{key:category.slug,staticClass:"saas-listing-page__categories-item"},[_c('nuxt-link',{staticClass:"saas-listing-page__categories-link",class:{
          'saas-listing-page__categories-link--active':
            category.slug === _vm.selectedCategory,
        },attrs:{"to":{
          name: 'blog-filtered',
          params: {
            category: category.slug,
          },
        }}},[_vm._v(_vm._s(category.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }